export enum AnsweredBy {
  HUMAN = "human",
  MACHINE_START = "machine_start",
  MACHINE_END_BEEP = "machine_end_beep",
  MACHINE_END_SILENCE = "machine_end_silence",
  MACHINE_END_OTHER = "machine_end_other",
  FAX = "fax",
  UNKNOWN = "unknown",
}

export function isMachineAnsweredBy(answeredBy?: string | null): boolean {
  return answeredBy != null && (answeredBy.startsWith("machine") || answeredBy === AnsweredBy.FAX);
}
